import { render, staticRenderFns } from "./Workflow-PolicyFinder_dev.vue?vue&type=template&id=935f478c&"
import script from "./Workflow-PolicyFinder_dev.vue?vue&type=script&lang=js&"
export * from "./Workflow-PolicyFinder_dev.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports